import Button from '@zenbusiness/zui/Button';
import Dialog from '@zenbusiness/zui/Dialog';
import DialogActions from '@zenbusiness/zui/DialogActions';
import DialogContent from '@zenbusiness/zui/DialogContent';
import DialogTitle from '@zenbusiness/zui/DialogTitle';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import CloseIcon from '@mui/icons-material/Close';

const DialogStyle = () => ({
  padding: 0
});

const TitleStyle = ({ theme, deviceType }) => ({
  '@media screen and (orientation:landscape)': {
    color: deviceType === 'mobile' ? theme.palette.text.primary : theme.palette.text.primary
  },
  [theme.breakpoints.up('lg')]: {
    ...theme.typography.xl
  }
});

const DialogTitleStyle = ({ theme, deviceType }) => ({
  padding: '16px 20px',
  position: 'relative',
  zIndex: 300,
  backgroundColor: theme.palette.background.grey.main,
  top: 0,
  left: 0,
  right: 0,
  height: '52px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '@media screen and (orientation:landscape)': {
    position: 'absolute',
    backgroundColor: deviceType === 'mobile' ? 'transparent' : theme.palette.background.grey.main,
    padding: deviceType === 'mobile' ? '16px 40px' : '16px 20px'
  },
  [theme.breakpoints.up('sm')]: {
    height: '56px'
  },

  [theme.breakpoints.up('lg')]: {
    height: '68px'
  }
});

const DialogContentStyle = ({ theme }) => ({
  padding: '0',
  backgroundColor: theme.palette.background.grey.main,
  overflow: 'initial'
});

const ImageStyle = ({ theme, deviceType }) => ({
  width: '100%',
  height: 'auto',
  '@media screen and (orientation:landscape)': {
    height: deviceType === 'mobile' ? '100%' : 'auto'
  },
  [`${theme.breakpoints.up('sm')} and (orientation: portrait)`]: {
    maxWidth: '660px'
  },

  [theme.breakpoints.up('md')]: {
    maxWidth: '940px'
  },

  [theme.breakpoints.up('lg')]: {
    maxWidth: '1072px'
  },

  [theme.breakpoints.up('xl')]: {
    maxWidth: '1198px'
  }
});

const ImageContainerStyle = ({ theme, deviceType }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  direction: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  [theme.breakpoints.up('sm')]: {
    alignItems: 'start',
    padding: '132px 0'
  },

  '@media screen and (orientation:landscape)': {
    padding: deviceType === 'mobile' ? 0 : '132px 0',
    height: deviceType === 'mobile' ? '100%' : 'auto'
  }
});

const CloseIconStyle = ({ theme, deviceType }) => ({
  '@media screen and (orientation:landscape)': {
    color: deviceType === 'mobile' ? theme.palette.text.primary : theme.palette.text.primary
  }
});

const DialogActionsStyle = () => ({
  width: '100%',
  padding: '16px',
  '@media screen and (orientation:landscape)': {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '24px'
  }
});

const ActionBoxStyle = () => ({
  width: '100%',
  flexDirection: 'row',
  gap: '8px',
  justifyContent: 'center'
});

const ButtonStyle = () => ({
  borderRadius: '16px',
  height: '56px',
  width: '100%',
  padding: '0 20px',
  border: 'none',
  boxShadow: 'none',
  '@media screen and (orientation:landscape)': {
    borderRadius: '14px',
    height: '46px',
    width: '160px'
  }
});

export const DialogStyled = styled(Dialog, { shouldForwardProp: (prop) => prop !== 'deviceType' })(
  DialogStyle
);
export const DialogTitleStyled = styled(DialogTitle, {
  shouldForwardProp: (prop) => prop !== 'deviceType'
})(DialogTitleStyle);
export const TitleStyled = styled(Text, { shouldForwardProp: (prop) => prop !== 'deviceType' })(
  TitleStyle
);
export const CloseButtonStyled = styled(CloseIcon, {
  shouldForwardProp: (prop) => prop !== 'deviceType'
})(CloseIconStyle);
export const ImageContainerStyled = styled('div', {
  shouldForwardProp: (prop) => prop !== 'deviceType'
})(ImageContainerStyle);
export const ImageStyled = styled('img', { shouldForwardProp: (prop) => prop !== 'deviceType' })(
  ImageStyle
);
export const ActionBoxStyled = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'deviceType'
})(ActionBoxStyle);
export const DialogActionsStyled = styled(DialogActions, {
  shouldForwardProp: (prop) => prop !== 'deviceType'
})(DialogActionsStyle);
export const DialogContentStyled = styled(DialogContent, {
  shouldForwardProp: (prop) => prop !== 'deviceType'
})(DialogContentStyle);
export const ButtonStyled = styled(Button, { shouldForwardProp: (prop) => prop !== 'deviceType' })(
  ButtonStyle
);
